import React from 'react';
import './WhyNow.css';

const WhyNow: React.FC = () => {
  return (
    <section className="why-now section" id="why-now">
      <div className="container">
        <div className="why-now__content">
          <h2 className="why-now__title heading-2">
            AI is getting extraordinarily good at finding patterns, mapping dependencies, and processing complexity at a scale no human team can match.
          </h2>
          <div className="why-now__text">
            <p>
              But AI can only work with what it has access to. And the most valuable context in any organization is rarely captured in a system where AI can reach it. The industry knowledge built over years. The reason behind a number that looks wrong. The insight from a conversation that shaped a decision.
            </p>
            <p className="why-now__highlight">
              Furudio is how you change that. It creates the structure where the right knowledge gets captured, interpreted, and made available: for better human decisions today, and for AI that actually understands your organization tomorrow.
            </p>
            <p className="why-now__conclusion">
              That is what the Furudio Method is built to do.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNow;
